import { pipe } from 'ramda';

import { IRootState } from '../../../../store/root.types';

const pathToRedirectState = (state: IRootState) => state.recipient.redirect;

export const getUrl = pipe(pathToRedirectState, state => state.url);

export const getTimeout = pipe(pathToRedirectState, state => state.timeout);

export const getMessage = pipe(pathToRedirectState, state => state.message);

export const getTitle = pipe(pathToRedirectState, state => state.title);
